<template>
  <div class="page-content-wrapper">
    <div class="content">
      <div class="container-fluid container-fixed-lg">
        <div class="row p-3">
          <div class="col-lg-12">
            <h2 class="text-dag">{{ $t('info_faq') }}</h2>
            <div class="receptdiv"><p class="sectiontitle2 text-muted">{{ $t('menu_faq') }}</p></div>
          </div>
        </div>
        <div class="row p-3">
          <div class="col-lg-3 m-b-10"
               v-for="faq in getFAQ">
              <div class="card no-border widget-loader-circle no-padding rounded h-100">
                  <router-link class="card-link-24"
                               :to="{ name: 'faqpage', params: { faq_id: faq.Id} }">
                      <div class="card-header"
                           :class="getShiftClass.box[0]">
                      </div>
                      <div class="card-body text-center p-t-20 p-b-30">
                          <div class="card-icon"
                               v-if="faq.Image">
                              <img :src="require(`@/assets/img/Food icons/${faq.Image}`)" width="100">
                          </div>
                          <div class="card-link card-link-24"
                               :class="getShiftClass.td[0]">
                              {{ faq.Title }}
                          </div>
                      </div>
                  </router-link>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'getShiftClass',
      'getFAQ',
    ]),
  },
  methods: {
    ...mapActions([
      'loadFAQ',
    ]),
  },
  created() {
    this.loadFAQ()
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/info/FAQ.vue